module.exports = __webpack_public_path__ + "img/mayflag.24bf8670.svg";